import type { FaireProductEntity } from "../../entity_types/product";

export const p_gbyb8hy4s2: FaireProductEntity = {
  token: "p_gbyb8hy4s2",
  type: "product",
  name: "Indian Cotton Print Wrap Skirt (Assorted)",
  brandToken: "b_vn9q3djcqf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4f659dc4c73173d355e577d4956054080635990c390e901e2648ce8dc3753b26.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4d8dfabdd367e8e4b95f891e45d89b3000c01b0ef687a19ed9472e4961c5bf1.jpeg",
    "https://cdn.faire.com/fastly/12d1f1d67f2d8d9fddd2e27de62e96357a719fd66e7cf87292680daa56360900.jpeg",
    "https://cdn.faire.com/fastly/3668722544ea4388625f1e2a9c0660379e972565f07f53d051cd67c88b2aecf9.jpeg",
    "https://cdn.faire.com/fastly/521a28aed470429a0472eac9c3cba980845c8b91201aaf0ae9a1ad3b96393c6e.jpeg",
  ],
  priceDollars: 24.94,
  description:
    'Wear it, and it becomes more than a skirt – it’s a narrative, a piece of art, a slice of tradition. In a world where much is transient, this skirt offers a connection to something lasting, to the artisans of Nepal, to the traditions of craftsmanship, to the principles of fair trade. It\'s not merely clothing; it\'s a lifestyle choice, a story told, a truth lived.\n\nBrand: Katmandu Trading Company\nCountry Of Origin: Handmade in Nepal\nAvailability: Limited\nMaterial: Cotton\nSizing: Free size, Length - 38" Width - 48" Depth - 0.1"\nSpecial Features: Wrinkle-resistant, natural dyes\nAdditional Information: Machine washable',
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:41.865Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
